"use client";
import { IconSearch } from "@/lib/icons";

import { usePathname, useSearchParams } from "next/navigation";
import { useState, useEffect, useContext, useRef } from "react";
import styles from "../Header/header.module.css";
import { useRouter } from "next/navigation";
import { locationcontext } from "@/lib/context";
import { Skeleton } from "antd";
import Link from "next/link";
export default function Search({ data }) {
  const pathname = usePathname();
  const router = useRouter();
  const searchParams = useSearchParams();
  const { loading } = useContext(locationcontext);
  const [query, setQuery] = useState(searchParams.get("q") || "");
  const [placeholderIndex, setPlaceholderIndex] = useState(0);

  // Cycle through search placeholders
  useEffect(() => {
    if (data?.search_placeholders && data.search_placeholders.length > 1) {
      const interval = setInterval(() => {
        setPlaceholderIndex(prev => (prev + 1) % data.search_placeholders.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [data?.search_placeholders]);

  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    const delayDebounce = setTimeout(() => {
      const params = new URLSearchParams(searchParams.toString());
      if (query) {
        params.set("q", query);
      } else {
        params.delete("q");
      }
      router.push(`?${params.toString()}`);
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [query]);

  const placeholder = data?.search_placeholders?.[placeholderIndex]?.content || "search...";

  return (
    <>
      {loading ? (
        <Skeleton.Input active size="large" className="!w-full" />
      ) : pathname !== "/search" ? (
        <Link href="/search" className={styles.searchWrap} prefetch>
          <IconSearch size={16} color="var(--color-grey)" />
          <span className="ml-[10px] text-[#858788]">{placeholder}</span>
        </Link>
      ) : null}
    </>
  );
}
